export default __webpack_public_path__ + "static/O0228-d0afc9324deab94619725b3cb4a85adf.png";